// extracted by mini-css-extract-plugin
module.exports = {"menu":"Menu_menu__3HBbF"};